export default [
  {
    name: 'vehicle-group-create',
    path: '/vehicles/groups/create',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'vehicle' }
  },
  {
    name: 'vehicle-group-edit',
    path: '/vehicles/groups/:id/edit',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'vehicle' }
  },
  {
    name: 'vehicle-group-view',
    path: '/vehicles/groups/:id/view',
    component: () => import('@/views/groups/GroupsManage'),
    props: { groupType: 'vehicle' }
  },
  {
    name: 'vehicle-group-find',
    path: '/vehicles/groups/find',
    component: () => import('@/views/groups/GroupsFind'),
    props: { groupType: 'vehicle' }
  }
]



// WEBPACK FOOTER //
// ./src/router/routeVehicleGroups.js